import React from 'react';

import CreatableSelect from 'react-select/creatable';

import { VsiSelectLabel } from "../styled/VsiLabeledSelect.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import themeStyles from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function VsiCreatableSelect(
	{
		options,
		defaultValue,
		isDisabled,
		isLoading,
		label,
		maxWidth,
		minWidth,
		onChange,
		isMulti,
		onCreateOption,
		placeholder,
	}) {
	const { theme } = useVsiAppContext();
	const customStyles = {
		control: (base, state) => ({
			...base,
			background: themeStyles[theme].altBgColor,
			color: themeStyles[theme].textColor,
			// match with the menu
			borderRadius: 5,
		}),
		input: (base) => ({
			...base,
			color: themeStyles[theme].textColor,
		}),
		singleValue: base => ({
			...base,
			color: themeStyles[theme].textColor,
			
		}),
		menu: base => ({
			...base,
			// override border radius to match the box
			borderRadius: 0,
			// kill the gap
			marginTop: 0,
			color: themeStyles[theme].textColor,
			"&:hover": {
				// Overwrittes the different states of border
				background: themeStyles[theme].sideBgColor,
			}
		}),
		menuList: base => ({
			...base,
			// kill the white space on first and last option
			padding: 0,
			color: themeStyles[theme].textColor,
			background: themeStyles[theme].altBgColor,
		}),
		option: (base, { isFocused, isDisabled, isSelected, data }) => ({
			...base,
			color: themeStyles[theme].textColor,
			backgroundColor: isSelected ? themeStyles[theme].navItemBgActive : themeStyles[theme].sideBgColor,
			":hover": {
				// Overwrittes the different states of border
				...base[":hover"],
				color: themeStyles[theme].textColor,
				opacity: .6
				
			},
		})
	};
	
	
	return (
		<div style={{
			maxWidth: maxWidth || 200,
			minWidth: minWidth || 150
		}}>
			<VsiSelectLabel>{label}</VsiSelectLabel>
			<CreatableSelect
				className="basic-single neutral90 mb-2 me-2"
				classNamePrefix="select"
				value={defaultValue ?? null}
				// isClearable
				isDisabled={isDisabled}
				isLoading={isLoading}
				onChange={onChange}
				onCreateOption={onCreateOption}
				isSearchable={true}
				name="color"
				options={options}
				placeholder={placeholder}
				styles={customStyles}
				isMulti={isMulti}
			/>
		</div>
	)
}

export default withErrorBoundary(VsiCreatableSelect, GeneralErrorBoundary);
